export default {
    namespaced: true,

    state: {
        userData: {},
    },
    mutations: {
        changeUserData (state, newUserData) {
            state.userData = newUserData;
        },
    },
    actions: {
        changeUserData({ commit }, userData) {
            commit('changeUserData', userData);
            return userData;
        },
    },
    getters: {
        userMetaData: state => state.userData,
    },
}
